export function getBooleanOptions(localized) {
  return [
    {
      label: (localized && localized['yes']) || 'Yes',
      value: 'true'
    },
    {
      label: (localized && localized['no']) || 'No',
      value: 'false'
    }
  ];
}
